<div
  *ngIf="formStageProject && editorReady"
  class="main-content profile-editor-page project-admin-editor-page project-stage-editor-page"
>
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ pageTitle }}</h1>
        <p>{{ pageDescription }}</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">
          Regresar
        </button>
        <button *ngIf="!modeEditable" type="button" class="app-form-btn app-form-btn--secondary" (click)="clear()">
          Limpiar
        </button>
        <button
          type="button"
          class="app-form-btn app-form-btn--primary"
          (click)="save()"
          [disabled]="!canSaveStage()"
        >
          Guardar etapa
        </button>
      </div>
    </section>

    <section class="profile-editor-page__card">
      <div class="profile-editor-page__card-body">
        <div class="project-stage-editor-page__summary">
          <article class="project-stage-editor-page__summary-card">
            <span class="project-stage-editor-page__summary-label">Proyecto</span>
            <strong>{{ projectContextLabel }}</strong>
            <p>La etapa se registra dentro del flujo operativo actual del proyecto.</p>
          </article>

          <article class="project-stage-editor-page__summary-card">
            <span class="project-stage-editor-page__summary-label">Planeación base</span>
            <strong>
              {{ data?.proyecto?.fechaInicio | date : "dd/MM/yyyy" }} -
              {{ data?.proyecto?.fechaFin | date : "dd/MM/yyyy" }}
            </strong>
            <p>La fecha mínima permitida parte del rango definido para el proyecto.</p>
          </article>
        </div>

        <div class="project-admin-editor-page__wizard-nav" role="tablist" aria-label="Flujo de captura de etapa">
          <button
            type="button"
            class="project-admin-editor-page__wizard-step"
            [class.is-active]="step === 0"
            [class.is-enabled]="true"
            (click)="setStep(0)"
          >
            <span class="project-admin-editor-page__wizard-step-index">1</span>
            <span class="project-admin-editor-page__wizard-step-copy">
              <strong>Etapa</strong>
              <small>Nombre, responsables y rango</small>
            </span>
          </button>

          <button
            type="button"
            class="project-admin-editor-page__wizard-step"
            [class.is-active]="step === 1"
            [class.is-enabled]="true"
            (click)="setStep(1)"
          >
            <span class="project-admin-editor-page__wizard-step-index">2</span>
            <span class="project-admin-editor-page__wizard-step-copy">
              <strong>Desarrollo</strong>
              <small>Recursos de implementación</small>
            </span>
          </button>

          <button
            type="button"
            class="project-admin-editor-page__wizard-step"
            [class.is-active]="step === 2"
            [class.is-enabled]="true"
            (click)="setStep(2)"
          >
            <span class="project-admin-editor-page__wizard-step-index">3</span>
            <span class="project-admin-editor-page__wizard-step-copy">
              <strong>QA</strong>
              <small>Tester y cierre operativo</small>
            </span>
          </button>
        </div>

        <div class="project-stage-editor-page__legacy-shell">
          <form [formGroup]="formStageProject" autocomplete="off">
            <mat-accordion class="project-stage-editor-page__accordion">
              <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>Etapa</mat-panel-title>
                  <mat-panel-description>
                    Registro base y responsables
                    <mat-icon>category</mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="row project-admin-editor-page__form-grid">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Nombre de etapa</mat-label>
                      <input
                        cdkFocusInitial
                        matInput
                        #nameStageCtrl
                        required
                        formControlName="nameStageCtrl"
                        [(ngModel)]="objectEtapa.nombre"
                        oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"
                        maxlength="45"
                        aria-label="Nombre de etapa"
                      />
                    </mat-form-field>

                    <mat-error
                      *ngIf="
                        formStageProject.controls.nameStageCtrl.invalid &&
                        (formStageProject.controls.nameStageCtrl.dirty ||
                          formStageProject.controls.nameStageCtrl.touched) &&
                        formStageProject.controls.nameStageCtrl.errors?.required
                      "
                    >
                      El campo es requerido.
                    </mat-error>
                  </div>

                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Descripción</mat-label>
                      <textarea
                        matInput
                        formControlName="descriptionProjectCtrl"
                        [(ngModel)]="objectEtapa.descripcion"
                        oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"
                        maxlength="400"
                        aria-label="Descripción"
                      ></textarea>
                    </mat-form-field>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Líder de proyecto</mat-label>
                      <mat-select
                        formControlName="bossCtrl"
                        [(ngModel)]="objectEtapa.idLiderEtapa"
                        (selectionChange)="selectedBoss()"
                        required
                      >
                        <mat-option *ngFor="let item of listLider" [value]="item.idEmpleado">
                          {{ item.persona.nombreCompleto }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error
                      *ngIf="
                        formStageProject.controls.bossCtrl.invalid &&
                        (formStageProject.controls.bossCtrl.dirty ||
                          formStageProject.controls.bossCtrl.touched) &&
                        formStageProject.controls.bossCtrl.errors?.required
                      "
                    >
                      El campo es requerido.
                    </mat-error>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Fecha inicio</mat-label>
                      <input
                        matInput
                        formControlName="dateStartCtrl"
                        [matDatepicker]="dateStart"
                        readonly
                        [(ngModel)]="objectEtapa.fechaInicio"
                        [min]="minDate"
                        aria-label="Fecha inicio"
                      />
                      <mat-datepicker-toggle matSuffix [for]="dateStart"></mat-datepicker-toggle>
                      <mat-datepicker #dateStart></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="formStageProject.controls.dateStartCtrl.errors?.required">
                      El campo es requerido.
                    </mat-error>
                  </div>

                  <div class="col-md-4">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Fecha fin</mat-label>
                      <input
                        matInput
                        formControlName="dateEndCtrl"
                        [matDatepicker]="dateEnd"
                        readonly
                        [(ngModel)]="objectEtapa.fechaFin"
                        [min]="minDate"
                        aria-label="Fecha fin"
                      />
                      <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                      <mat-datepicker #dateEnd></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="formStageProject.controls.dateEndCtrl.errors?.required">
                      El campo es requerido.
                    </mat-error>
                  </div>
                </div>

                <mat-action-row>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="nextStep()">
                    Siguiente
                  </button>
                </mat-action-row>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>Equipo de desarrollo</mat-panel-title>
                  <mat-panel-description>
                    Asignación operativa de recursos
                    <mat-icon>group</mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <app-asignacion-equipo-desarrollo
                  [recursosAsignadosDevelopers]="objectEtapa.recursosAsignados"
                  (emmitResourcesDevelopers)="resourcesSelectedDevelopers($event)"
                ></app-asignacion-equipo-desarrollo>

                <mat-action-row>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="prevStep()">
                    Anterior
                  </button>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="nextStep()">
                    Siguiente
                  </button>
                </mat-action-row>
              </mat-expansion-panel>

              <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>Equipo de QA</mat-panel-title>
                  <mat-panel-description>
                    Validación y cierre de etapa
                    <mat-icon>group</mat-icon>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="row project-admin-editor-page__form-grid">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="profile-editor-page__field">
                      <mat-label>Líder de QA</mat-label>
                      <mat-select
                        formControlName="bossQACtrl"
                        [(ngModel)]="objectEtapa.idLiderEtapaQA"
                        (selectionChange)="selectedBossQA()"
                        required
                      >
                        <mat-option *ngFor="let item of listLiderQA" [value]="item.idEmpleado">
                          {{ item.persona.nombreCompleto }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error
                      *ngIf="
                        formStageProject.controls.bossQACtrl.invalid &&
                        (formStageProject.controls.bossQACtrl.dirty ||
                          formStageProject.controls.bossQACtrl.touched) &&
                        formStageProject.controls.bossQACtrl.errors?.required
                      "
                    >
                      El campo es requerido.
                    </mat-error>
                  </div>
                </div>

                <app-asignacion-equipo-qa
                  [recursosAsignadosQA]="objectEtapa.recursosAsignados"
                  (emmitResourcesQA)="resourcesSelectedQA($event)"
                >
                </app-asignacion-equipo-qa>

                <mat-action-row>
                  <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="prevStep()">
                    Anterior
                  </button>
                  <button
                    type="button"
                    class="app-form-btn app-form-btn--primary app-form-btn--compact"
                    (click)="save()"
                    [disabled]="!canSaveStage()"
                  >
                    Guardar etapa
                  </button>
                </mat-action-row>
              </mat-expansion-panel>
            </mat-accordion>
          </form>
        </div>
      </div>
    </section>
  </div>
</div>
